import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { BlockGrid as ZinniaBlockGrid, Button, HeadingLevel, } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { SEMANTIC_COLORS, } from '../../constants';
import { Section } from '../Section/Section';
import { useTracking } from '../../tracking';
import { Fragment } from 'react';
const styles = labelStyles('BlockGrid', {
    footer: css({
        display: 'flex',
        justifyContent: 'center',
        paddingTop: '90px',
    }),
});
const Wrapper = ({ heading, children, }) => heading ? (_jsx(HeadingLevel, { children: children })) : (_jsx(Fragment, { children: children }));
export function BlockGrid({ backgroundColor, children, ctaColor = SEMANTIC_COLORS.primaryAlt, ctaHref, ctaText, maxColumns, sectionHeading, sectionHeadingSize, sectionSubheading, }) {
    const { emitUserInteractionEvent } = useTracking();
    const shouldDisplayFooter = !!ctaHref && !!ctaText;
    return (_jsx(Wrapper, Object.assign({ heading: sectionHeading }, { children: _jsxs(Section, Object.assign({ background: backgroundColor, contentWidth: "fullWidth", heading: sectionHeading, headingSize: sectionHeadingSize, subheading: sectionSubheading }, { children: [_jsx(ZinniaBlockGrid, Object.assign({ maxColumns: maxColumns }, { children: children })), shouldDisplayFooter && (_jsx("div", Object.assign({ css: styles.footer }, { children: _jsx(Button, Object.assign({ color: ctaColor, href: ctaHref, onClick: () => {
                            emitUserInteractionEvent({
                                event_action: 'click',
                                interaction_name: 'call_to_action',
                                interaction_raw_text: ctaText,
                                destination_href: ctaHref,
                                option_selected: 'cta_button',
                            });
                        } }, { children: ctaText })) })))] })) })));
}
//# sourceMappingURL=BlockGrid.js.map